<template>
    <div style="width:100%">
      <el-tooltip class="item" effect="dark" :content="$t('msg.searchCRHint')" placement="top">        
        <el-select v-model="selectValue" filterable remote  :remote-method="remoteMethod" clearable :loading="loading" @change="() => this.$emit('sync-select-cr', selectValue)" 
            style="display:block;" :placeholder="$t('msg.fuzzy1WordSearch')" loading-text="loading..." :no-match-text="$t('msg.noDataFound')" :no-data-text="$t('msg.noDataFound')" :disabled="pOnlyView">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>   
      </el-tooltip>
    </div>
</template>

<script>

import { apiFindCRByCondition2 } from "../../utils/api.js";
import authHeader from "../../services/auth-header";


export default {   
    props: {
      pSelectValue: {
        type: String
      },
      pOnlyView: {
        type: Boolean,
        default: false
      },
      pStatusCondition: {
        type: String
      }  
    },
    data() {
      return {
        options: [],
        loading: false,
        selectValue:''
      }
    },
    watch:{
      pSelectValue: function(){        
        if(this.pSelectValue == null || this.pSelectValue ==''){
            this.selectValue = '';
            this.options = [];
        }else{
          this.selectValue = this.pSelectValue;
        }
      } 
    },
    mounted(){
      if(this.pSelectValue != null && this.pSelectValue !=''){
        
        
        apiFindCRByCondition2({ headers: authHeader(), condition:this.pSelectValue, condition1:this.pStatusCondition}).then((response) => { 
          if(response.data != null && response.data.length > 0 ){
            this.selectValue = response.data[0].requestNo+'('+this.reason+')';
          }else{
            this.selectValue = this.pSelectValue;
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    },
    methods: {
      remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          apiFindCRByCondition2({ headers: authHeader(), condition:query, condition1:this.pStatusCondition}).then((response) => { 
            this.options = [];
            var temp = [];
            response.data.forEach( function ( item, index, array)  {    
              temp.push({value:item.id, label: item.requestNo + '(' + item.reason + ')' });
            });
            this.options = temp; 
            this.loading = false;
          }).catch((err) => {
            console.log(err);
          });

        } else {
          this.options = [];
        }
      }
    }
}
</script>

<style scoped>
   
</style>